module.exports = __webpack_public_path__ + "static/fipcspottyg3-986a0799fd998c328c8bd3e9974809da.jpeg";